import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import congratulation from "./../../../Images/congratulation-img.png";
import "./HowtoQuantman.css";
function HowtoQuantman(props) {
  console.log(props);
  return (
    <>
      <section className="howtostart_section howtoQuantman">
        <div className="howtostart_main">
        <div className="container">
          <div class="page_heading"><h2><span>How to Start</span></h2></div>
          <div className="row justify-content-center">
            <div className="col-md-11">
              <div className="howtostart_grid">
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>1</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Get Started</h3>
                      <p>Register with Moneysukh and then sign up with Quantman</p>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_text media-body">
                      <h3>Select Strategy</h3>
                      <p>Log in to quantman and Go to Market place. </p>
                    </div>
                    <div className="howtostart_icon">
                      <span>2</span>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>3</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Select a Plan</h3>
                      <p> You can select any premium strategy by taking monthly subscription through “Buy plan “ on the top bar</p>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_text media-body">
                      <h3>Option Builder</h3>
                      <p> Select “option builder” for any pre built option strategies</p>
                    </div>
                    <div className="howtostart_icon">
                      <span>4</span>
                    </div>
                  </div>
                </div>
                <div className="howtostart_group">
                  <div className="howtostart_panel media align-items-center">
                    <div className="howtostart_icon">
                      <span>5</span>
                    </div>
                    <div className="howtostart_text media-body">
                      <h3>Start Trading</h3>
                      <p> Now fill the required conditions and back test your strategy before any live deployment</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      <section className="congratulation_section">
        <div className="container">
          <div class="page_heading"><h2>Congratulations!</h2></div>
          <div className="congratulation_text text-center">
            <div className="congratulation_img">
              <img className="img-fluid" src={congratulation} alt="congratulation" />
            </div>
            <h3>You've just put your first Quantman <br></br>strategy into action.</h3>
          </div>
        </div>
      </section>
      <section className="ctest_section py-5 d-none">
        <div className="container">
          <div class="page_heading"><h2>fgfdf!</h2></div>
          <div className="congratulation_text text-center">
            <div className="congratulation_img">
              <img className="img-fluid" src={congratulation} alt="congratulation" />
            </div>
            <h3>You've just put your first <br></br>Quantman strategy into action.</h3>
          </div>
        </div>
      </section>
    </>
  );
}
export default HowtoQuantman;
